import { render, staticRenderFns } from "./PopupCreateShipLog.vue?vue&type=template&id=c5cb13c0&scoped=true"
import script from "./PopupCreateShipLog.vue?vue&type=script&lang=js"
export * from "./PopupCreateShipLog.vue?vue&type=script&lang=js"
import style0 from "./PopupCreateShipLog.vue?vue&type=style&index=0&id=c5cb13c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5cb13c0",
  null
  
)

export default component.exports